import { Component } from '@angular/core';

@Component({
    selector: 'ca-spinner-icon',
    templateUrl: './spinner.icon.component.html',
    styleUrls: ['./spinner.icon.component.scss'],
})
export class SpinnerIconComponent {}
